module.exports = __webpack_public_path__ + "static/media/script.82737dc6.svg";